var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customClass')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.customClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "customClass", $$v)
      },
      expression: "optionModel.customClass"
    }
  }, _vm._l((_vm.cssClassList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb7600d","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/customClass-editor.vue
// module id = null
// module chunks = 